<template>
  <v-card>
    <v-data-table :headers="headers_tipi" :items="items_tipi">
      <template v-slot:top>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Tipi di Commessa
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Bottone di modifica -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickAddTipo" small v-bind="attrs" v-on="on">
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Tipo Commessa</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone per tornare indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickBack" small v-bind="attrs" v-on="on">
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
      </template>

      <!-- Colonna di modifica -->
      <template v-slot:[`item.modifica`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="item.id_tabella != null"
              @click="clickEditTipo(item)"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Modifica Tipo</span>
        </v-tooltip>
      </template>

      <!-- Colonna delle associazioni -->
      <template v-slot:[`item.associazioni`]="{ item }">
        <v-icon
          color="primary"
          class="mr-5"
          @click="clickEditAssociazioni(item)"
        >
          mdi-magnify
        </v-icon>
        <span
          class="mr-3"
          v-for="(associazione, i) in item.associazioni"
          :key="i"
        >
          <span>{{
            `${associazione.cod_report}${
              i == item.associazioni.length - 1 ? "" : ","
            } `
          }}</span>
        </span>
      </template>

      <!-- Colonna di eliminazione -->
      <template v-slot:[`item.elimina`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickDeleteTipo(item)"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="error"> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Elimina Tipo</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Dialog aggiunta / modifica tipologia -->
    <v-dialog v-model="dialog_edit_tipo" persistent width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Tipologia </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salvaEditTipo" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_edit_tipo = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-container fluid>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                label="Descrizione"
                v-model="tipo_sel.des"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog delle associazioni -->
    <v-dialog v-model="dialog_associazioni" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Associazioni </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="setReportCommessa" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_associazioni = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" dense justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_report_selezionati"
                  :items="items_report_selezionati"
                >
                  <template v-slot:[`item.selezione`]="{ item }">
                    <v-simple-checkbox
                      color="success"
                      v-model="item.selezione"
                    ></v-simple-checkbox>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei tipi -->
    <v-dialog v-model="conferma_delete_tipo" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare il tipo commessa selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn @click="conferma_delete_tipo = false" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="deleteTipo" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>
<script>
class Tipo {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : JSON.parse(JSON.stringify(arg[c.nome]))
            : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "associazioni", complex: true, default_val: new Array() },
      { nome: "des", complex: false, default_val: null },
      { nome: "id_tabella", complex: false, default_val: null },
      { nome: "tipo", complex: false, default_val: "COMMESSA_TIPO" },
      { nome: "validita", complex: false, default_val: null },
    ];

    return campi;
  }
}

export default {
  name: "ReportCommessa",
  components: {},
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      tipo_sel: new Object(),

      // Modal
      conferma_delete_tipo: false,
      dialog_associazioni: false,
      dialog_edit_tipo: false,
      overlay: false,

      // Array
      headers_report_selezionati: [
        {
          text: "Selezione",
          value: "selezione",
          sortable: false,
          width: "150px",
        },
        {
          text: "Cod. Report",
          value: "cod_report",
          sortable: false,
        },
      ],
      headers_tipi: [
        {
          text: "Modifica",
          value: "modifica",
          sortable: false,
          width: "150px",
        },
        {
          align: "start",
          text: "Tipo",
          value: "des",
          sortable: false,
          width: "250px",
        },
        {
          align: "start",
          text: "Report Associati",
          value: "associazioni",
          sortable: false,
        },
        { text: "Elimina", value: "elimina", sortable: false, width: "150px" },
      ],
      items_report: new Array(),
      items_report_selezionati: new Array(),
      items_tipi: new Array(),
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    clickBack() {
      this.$emit("click_chiudi");
    },
    clickAddTipo() {
      this.tipo_sel = new Tipo();
      this.dialog_edit_tipo = true;
    },
    clickDeleteTipo(arg) {
      this.tipo_sel = new Tipo(arg);
      this.conferma_delete_tipo = true;
    },
    clickEditAssociazioni(arg) {
      /* Costruisco le associazioni provvisorie in base ai report
       * e alle associazioni già presenti nell'argomento di funzione. */
      this.items_report_selezionati = new Array();

      this.items_report.forEach((r) => {
        const relazione_tmp = {
          selezione: false,
          cod_report: r.cod_report,
          id_relazione: -1,
          id_riferimento: r.id_label,
          pk_riferimento: "id_report",
          riferimento: "t_report",
          id_modulo: arg.id_tabella,
          pk_modulo: "id_tabella",
          modulo: "tabella",
          validita: 1,
        };

        if (arg.associazioni) {
          arg.associazioni.forEach((a) => {
            if (a.id_riferimento == r.id_label) {
              relazione_tmp.id_relazione = a.id_relazione;
              relazione_tmp.selezione = true;
            }
          });
        }

        this.items_report_selezionati.push(relazione_tmp);
      });

      this.dialog_associazioni = true;
    },
    clickEditTipo(arg) {
      this.tipo_sel = new Tipo(arg);
      this.dialog_edit_tipo = true;
    },
    deleteTipo() {
      const request = {
        controller: "Global",
        method: "PUT",
        richiesta: {
          action: "settabella",
          token: localStorage.user_token,
          tabella: [{ id_tabella: this.tipo_sel.id_tabella, validita: 0 }],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.getAssociazioniTipiReport();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getAssociazioniTipiReport() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getassociazionitipireport",
          token: localStorage.getItem("user_token"),
          tipo: "COMMESSA_TIPO",
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (res.data.result.tipi) {
              this.items_tipi = new Array();

              // Ordino i tipi perché voglio che il "non assegnato" sia in cima.
              res.data.result.tipi.sort((a, b) =>
                a.id_tabella < b.id_tabella
                  ? -1
                  : a.id_tabella > b.id_tabella
                  ? 1
                  : 0
              );

              // Aggiusto il tipo "Non assegnato" e gli id_modulo delle sue relazioni.
              res.data.result.tipi.forEach((t) => {
                if (t.id_tabella == -99) {
                  t.id_tabella = null;
                  if (t.associazioni) {
                    t.associazioni.forEach((a) => {
                      a.id_modulo = null;
                    });
                  }
                }
              });

              this.items_tipi = res.data.result.tipi;
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
          return false;
        });
    },
    getReport() {
      const request = {
        controller: "Label",
        method: "POST",
        richiesta: {
          action: "getreport",
          token: localStorage.getItem("user_token"),
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_report = res.data;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    async salvaEditTipo() {
      this.dialog_edit_tipo = false;
      await this.setTabella(this.tipo_sel);
      this.getAssociazioniTipiReport();
    },
    setReportCommessa() {
      const associazioni_tmp = new Array();

      this.items_report_selezionati.forEach((r) => {
        if (r.selezione === true || r.id_relazione > 0) {
          if (r.id_relazione > 0 && r.selezione === false) {
            r.validita = 0;
          }

          associazioni_tmp.push(JSON.parse(JSON.stringify(r)));
        }
      });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setreportcommessa",
          token: localStorage.getItem("user_token"),
          associazioni: associazioni_tmp,
        },
      };

      this.overlay = true;
      this.dialog_associazioni = false;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.getAssociazioniTipiReport();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    setTabella(arg) {
      const tipo_tmp = JSON.parse(JSON.stringify(arg));
      if (tipo_tmp.associazioni) {
        delete tipo_tmp.associazioni;
      }

      const request = {
        controller: "Global",
        method: "PUT",
        richiesta: {
          action: "settabella",
          token: localStorage.user_token,
          tabella: [tipo_tmp],
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
          return false;
        });
    },
  },
  created() {},
  async mounted() {
    await this.getAssociazioniTipiReport();
    this.getReport();
  },
};
</script>
<style scoped>
</style>